import {HostListener, Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ConfirmationModalService} from '../component/modal';
import {PlanModelService} from './plan-model.service';
import {SpatialUtilService} from '../../design/services/spatial-util.service';
import {switchMap} from 'rxjs/operators';
import {PlanLodgementService} from './plan-lodgement.service';
import {NgEventBus} from 'ng-event-bus';
import {PLAN_LODGEMENT_STAGE} from "../constants";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    skipUnloadCheck = false;

    constructor(
        private confirmationModalService: ConfirmationModalService,
        private planModelService: PlanModelService,
        private spatialUtilService: SpatialUtilService,
        private planLodgementService: PlanLodgementService,
        private eventBus: NgEventBus
    ) {}

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload($event: any) {
        if (!this.isDirty() || !this.planLodgementService.hasMinimumPlanDetails() || this.skipUnloadCheck) {
            return;
        }

        // display leave site warning
        $event.preventDefault();
    }

    isDirty(): boolean {
        return !this.planModelService.readonly && (this.planModelService.modelIsDirty() || this.spatialUtilService.hasEdits());
    }

    canDeactivate(): Observable<boolean> {
        if (!this.isDirty() || !this.planLodgementService.hasMinimumPlanDetails()
            || this.planModelService.model.planLodgementStage === PLAN_LODGEMENT_STAGE.LODGED) {
            this.skipUnloadCheck = true;
            return of(true);
        }
        return new Observable<boolean>(obs => {
            this.confirmationModalService
                .showModal({
                    title: 'Warning',
                    confirmationText: 'Do you want to save the plan?',
                    iconType: 'warning',
                    yes: 'Save',
                    no: "Don't save",
                    showCancel: true
                })
                .subscribe((action: string) => {
                    if (action === 'yes') {
                        const subscription = this.savePlanChanges().subscribe({
                            next: () => {
                                this.skipUnloadCheck = true;
                                obs.next(true);
                            }
                        });
                        this.eventBus.cast('nlr:busy', subscription);
                    } else if (action === 'no') {
                        this.skipUnloadCheck = true;
                        obs.next(true);
                    } else {
                        obs.complete();
                    }
                });
        });
    }

    savePlanChanges() {
        return this.spatialUtilService.save().pipe(switchMap(() => this.planLodgementService.save()));
    }
}
